const SIZES = {
  INPUT_LABEL_FONT_SIZE: 12,
  LARGE_BADGE_FONT_SIZE: 13,
  FONT: 14,
  BASE: 16,
};

export default SIZES;
